<template>
  <div>
    <!-- <div class="pt-5 pb-3 row bgrojo">
      <div class="col-4 offset-4 text-center">
        <img
          class="img-fluid"
          src="../assets/imgs/viaja/lamagiadecreer.png"
          alt="Verano con sabor a cinepolis"
        />
      </div>
    </div> -->

    <footer>
      <div class="container-fluid pt-5 pt-xl-3">
        <div class="row">
          <div class="col-12 col-lg-6 offset-lg-3 pb-3 text-center pt-xl-4">
            <img
              class="img-fluid px-4"
              src="../assets/imgs/verano23/logos-mars-cinepolis-coca-cola.png"
              alt="Mars Coca-Cola Cinépolis"
            />
          </div>

          <div class="col-12 col-lg-12 text-center text-center fT pb-3">
            <a
              target="_blank"
              href="#"
              class="negro terminos"
              >Términos y Condiciones</a
            >
            <!-- | Coca-Cola<sup>&reg;</sup> 2022 -->
          </div>
        </div>
        <div class="col-12 py-2 pt-2 text-center">
          <div class="">
           
            <p class="fC0">
              Verano con sabor a Cinépolis, es una promoción de habilidad y destreza. Vigente del 20 de abril al 14 de junio de 2023. Promoción válida solo en la República Mexicana. Consulta términos y condiciones. Las imágenes de los premios son ilustrativas, por lo que las características y especificaciones pueden variar. Las marcas utilizadas en esta publicidad son propiedad de sus respectivos titulares. HIDRÁTATE DIARIAMENTE. COCA-COLA SIN AZÚCAR y FANTA SIN AZÚCAR son marcas registradas de The Coca-Cola Company. D.R. © The Coca-Cola Company. 2023. COCA-COLA SIN AZÚCAR y FANTA SIN AZÚCAR, FENILCETONÚRICOS: CONTIENE FENILALANINA.
© 2023 Mars o Afiliadas

            </p>
          </div>
        </div>
      </div>
    </footer>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mostrar: true
    };
  },
  methods: {},
  mounted: function () {
    if (this.$route.name == "Dinamica") {
      this.mostrar = false;
    }
  },
};
</script>

